import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

import TimeAgo from '../TimeAgo';
import Card from '../Card';
import Avatar from '../Avatar';

function ActivityCard({user, action, activity, date, children}) {
  return (
    <Card>
      <Header>
        <Avatar size="2.75rem" user={user} />
        <Metadata>
          <Activity><Link to={`/users/${user.id}`}>{user.userName}</Link> {activity}</Activity>
          <Timestamp title={date.toLocaleString()}>
            Updated <TimeAgo date={date} />
          </Timestamp>
        </Metadata>
        <div>{action}</div>
      </Header>
      {children}
    </Card>
  );
}

const Header = styled.div`
  padding: 1.125rem 1.875rem;
  border-bottom: 0.0625rem solid #E2E4EA;
  display: flex;
  align-items: center;
`;

const Metadata = styled.div`
  flex: 1;
  padding: 0 0.875rem;
  min-width: 0;
`;

const Activity = styled.div`
  margin: 0;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Timestamp = styled.small`
  display: block;
  margin-top: 0.375rem;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;


export default ActivityCard;